import Facebook from "../../../assets/facebook.webp";
import LinkedIn from "../../../assets/linkedin.webp";
import Instagram from "../../../assets/instagram.webp";
import Logo from "../../../assets/solutions-logo.webp";
import Phone from "../../../assets/phone.webp";
import Location from "../../../assets/location.webp";
import Email from "../../../assets/email.webp";
import { Link } from "react-router-dom";
import "../../../App.css";

const Footer = () => {
    return (
        <footer>
            <div className="footer-inner">
                <div className="logo-social"> 
                    <div className="logo">
                        <Link to="/">
                            <img src={Logo} alt="logo" />
                        </Link>
                    </div>
                    <div className="socials">
                        <Link to="https://web.facebook.com/amoservsolutions" target="_blank">
                            <img src={Facebook} alt="Social link" />
                        </Link>

                        <Link to="https://www.linkedin.com/company/amorserv-solutions" target="_blank">
                            <img src={LinkedIn} alt="Social link" />
                        </Link>

                        <Link to="https://www.instagram.com/amorservsolutions" target="_blank">
                            <img src={Instagram} alt="Social link" />
                        </Link>
                    </div>
                </div>
                <div className="contact-details">
                    <h5>Get In Touch</h5>
                    <div className="details">
                        <div className="contact phone">
                            <img src={Phone} alt="Phone" />
                            <p>+1 (866) 217-3333</p>
                        </div>
                        <div className="contact location">
                            <img src={Location} alt="Location" />
                            <p>2340 West Touhy Avenue, Suite B, Chicago, Illinois 60645, United States</p>
                        </div>
                        <div className="contact email">
                            <img src={Email} alt="Location" />
                            <p>support@amorservsolutions.com</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copy">
                <p>
                    &copy;2023 Amorserv Solutions. All rights reserved
                </p>
            </div>
        </footer>
    )
}

export default Footer;